var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductWebIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_21600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FEC000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9542 17.2202C31.9846 16.8174 32.0001 16.4104 32.0001 15.9999C32.0001 15.7383 31.9938 15.4781 31.9814 15.2196L25.0159 8.38086L6.7937 21.6507L18.1626 31.855C24.3294 31.0217 29.3813 26.6752 31.2369 20.8965L31.2381 20.8888L31.4921 19.9999L31.7439 18.8666C31.7454 18.8583 31.747 18.8499 31.7485 18.8417L31.8684 18.062C31.871 18.0417 31.8736 18.0212 31.8761 18.0008L31.9542 17.2202Z",
    fill: "#EAB100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0739 8.39062H6.79883V21.6816H14.2751V23.343H12.6136V25.0044H19.2592V23.343H17.5977V21.6816H25.0739V8.39062ZM23.4126 20.0203H8.4602V10.052H23.4126V20.0203Z",
    fill: "#54698E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0159 8.38086H16V21.6888V25.0158H19.2785V23.3523H17.6392V21.6888H25.0159V8.38086ZM23.3766 20.0253H16V10.0444H23.3766V20.0253Z",
    fill: "#3C4F7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 10.0312H8.38086V20.063H15.9999V10.0312Z",
    fill: "#F0F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4921 10.0312H16V20.063H23.4921V10.0312Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8412 11.8086H10.1587V15.6181H13.8412V11.8086Z",
    fill: "#28B3E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6983 12.9531H11.4285V14.35H12.6983V12.9531Z",
    fill: "#F0F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5872 11.8086H15.238V13.0784H21.5872V11.8086Z",
    fill: "#989BC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5872 16.127H15.238V17.3968H21.5872V16.127Z",
    fill: "#989BC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5872 13.8418H15.238V15.2386H21.5872V13.8418Z",
    fill: "#989BC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_21600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductWebIcon);
export default __webpack_public_path__ + "static/media/product_web_icon.39828b8c3d982b72f88ab47154fa9938.svg";
export { ForwardRef as ReactComponent };